import React, { FC } from 'react';
import { RouteProps } from 'react-router';
import { Redirect, Route } from 'react-router-dom';
import { PagePathname } from 'utils/hooks/navigation/types';
import { useTenantCode } from 'utils/hooks/useTenantConfig';

interface MainRouteProps extends Omit<RouteProps, 'path'> {
  path: `/:tenantCode${PagePathname}` | `/documentation`;
  enabled?: boolean;
}

export const MainRoute: FC<React.PropsWithChildren<MainRouteProps>> = (props) => {
  const { enabled, ...rest } = props;
  const code = useTenantCode();
  const isConditional = 'enabled' in props;
  if (isConditional && !enabled) {
    return <Redirect to={`/${code}/myutmost`} />;
  }
  return <Route {...rest} />;
};
